import styles from "./SuccessState.module.css";

type Props = {
  agentName: string;
};

export const SuccessState = ({ agentName }: Props): JSX.Element => {
  const display = agentName.trim().length > 0 ? agentName.trim() : "your agent";
  return (
    <div className={styles.root}>
      <div className={styles.checkWrap} aria-hidden>
        <svg viewBox="0 0 24 24" className={styles.check} fill="none">
          <path
            d="M5 12.5l4.5 4.5L19 7.5"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <h3 className={styles.title}>Personalisation captured.</h3>
      <p className={styles.copy}>
        Launching {display}. We'll drop you into the dashboard in a moment.
      </p>
    </div>
  );
};
